<div class="error-wrapper">
  <div class="error-card">
    <div class="error-icon">
      <ngk-icon icon="alert-triangle" size="3rem" color="var(--color-warning-600)" />
    </div>
    <h1 class="error-title">We couldn't load your property</h1>
    <p class="error-desc">
      We weren't able to find a property on file for your account. Please give us a call and we'll get things sorted out.
    </p>
    <div class="error-phone">
      <ngk-icon icon="phone" size="1.1rem" color="var(--color-secondary-600)" />
      <a href="tel:8557170022" class="phone-link">855.717.0022</a>
    </div>
    <p class="error-hours">Mon–Fri, 9 AM – 6 PM CT</p>
  </div>
</div>
